var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mainCard', _vm.className],style:({ padding: _vm.padding + 'px', borderRadius: _vm.radius + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }